import { TenantAction } from "../../../shared/interfaces/reducers/reducer.interface";
import * as types from "../consts";

const initState = {
  detailsTenant: {},
  detailsTenantIsOk: null,
  tenantsList: {},
  tenantListIsOk: false,
  deleteTenant: {},
  updateTenant: {},
};

export default function tenantsReducer(
  state = initState,
  action: TenantAction
) {
  switch (action.type) {
    case types.GET_TENANT_DETAIL_REQUEST: {
      return { ...state };
    }
    case types.GET_TENANT_DETAIL_SUCCESS: {
      return {
        ...state,
        detailsTenant: action.response,
        detailsTenantIsOk: true,
      };
    }
    case types.GET_TENANT_DETAIL_ERROR: {
      return { ...state, detailsTenantIsOk: false };
    }
    // tenant list cases
    case types.GET_TENANTS_LIST_REQUEST: {
      return { ...state, tenantListIsOk: false };
    }
    case types.GET_TENANTS_LIST_SUCCESS: {
      return {
        ...state,
        tenantsList: action.response,
        tenantListIsOk: true,
      };
    }
    case types.GET_TENANTS_LIST_ERROR: {
      return { ...state };
    }
    case types.DELETE_TENANT_ROW_REQUEST: {
      return { ...state };
    }
    case types.DELETE_USER_V3_ROW_REQUEST: {
      return { ...state };
    }
    case types.DELETE_TENANT_ROW_SUCCESS: {
      return { ...state, deleteTenant: action.response };
    }
    case types.DELETE_TENANT_ROW_ERROR: {
      return { ...state };
    }
    case types.UPDATE_TENANT_ROW_REQUEST: {
      return { ...state };
    }
    case types.UPDATE_TENANT_ROW_SUCCESS: {
      return { ...state, updateTenant: action.response };
    }
    case types.UPDATE_TENANT_ROW_ERROR: {
      return { ...state };
    }
    case types.UPDATE_USER_V2_ROW_REQUEST: {
      return { ...state };
    }
    case types.UPDATE_USER_V2_ROW_SUCCESS: {
      return { ...state, updateTenant: action.response };
    }
    case types.UPDATE_USER_V2_ROW_ERROR: {
      return { ...state };
    }
    default: {
      return { ...state };
    }
  }
}
